"use strict";
var Observable_1 = require('../../Observable');
var pluck_1 = require('../../operator/pluck');
Observable_1.Observable.prototype.pluck = pluck_1.pluck;
//# sourceMappingURL=pluck.js.map


//////////////////
// WEBPACK FOOTER
// /deploy/www/v2/sa/app/emr-webapp/~/rxjs/add/operator/pluck.js
// module id = ../../../../rxjs/add/operator/pluck.js
// module chunks = 5